<template>
  <SustainabilityIndexTab
    :market="market"
    :title="titlePage"
    :subscription="subscription"
    :product="sustainabilityIndexSlug"
    :sustainability-indexes="sustainabilityIndexes"
    :vimeo-id="vimeoId"
    :initial-fields="initialFields"
  />
</template>

<script lang="ts" setup>
import SustainabilityIndexTab from '~/components/sustainability/SustainabilityIndexTab.vue'

import type { TMarketServiceConfig } from '~/src/types/markets'
import { SUSTAINABILITY_INDEXES } from '~/src/constants/sustainability'
import { ESG } from '~/constants/services/constants'
import { useSeo } from '~/composables/useSeo'

/*-------------------------------------
  Meta
-------------------------------------*/
definePageMeta({
  isTab: true,
  scrollToTop: false,
  middleware: 'redirect-tab',
})

/*-------------------------------------
  Props & Refs
-------------------------------------*/
const props = defineProps<{
  market: TMarketServiceConfig
  subscription: string
  initialFields: string[]
}>()

const { $config } = useNuxtApp()

const titlePage = `${props.market.name} ${ESG.name}`
const vimeoId = $config.public.IntroSustainabilityVimeoId
const sustainabilityIndexes = SUSTAINABILITY_INDEXES[props.market.slug]

const sustainabilityIndexSlug = props.market.slug

/*-------------------------------------
  SEO
-------------------------------------*/
const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: 'Lithium Sustainability Index',
  description:
    "The Benchmark Lithium Sustainability Index categorises lithium producers based on their ESG transparency and performance. This data is part of Benchmark's granular Lithium ESG Report, enabling sustainable sourcing for the battery supply chain.",
})
useHead(seo)
</script>
